module.exports = __webpack_public_path__ + "static/media/domru_business.6cf0d04b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos_2024/domru_business.png
// module id = 820
// module chunks = 0